import { SMLRouteNames, SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { SMLSectionTab } from '../components/SMLSectionTabs/SMLSectionTabs';
import { smlNavigationMessages } from '../navigation/smlNavigationMessages';

/**
 * The tabs of Insights (design navigation-v2 b): Streaming, Social, Fans. Each tab is its old
 * route, so old links and emails keep working. A Streaming section and a track keep the Streaming
 * screen, a post keeps the Social screen.
 */
export function insightsTabs(screen: SMLRouteNames | undefined): SMLSectionTab[] {
  return [
    {
      id: 'streaming',
      label: smlNavigationMessages.streaming,
      route: SMLRoutes.streaming,
      active: screen === SMLRouteNames.streaming,
    },
    {
      id: 'social',
      label: smlNavigationMessages.social,
      route: SMLRoutes.social,
      active: screen === SMLRouteNames.social,
    },
    {
      id: 'fans',
      label: smlNavigationMessages.fans,
      route: SMLRoutes.fans,
      active: screen === SMLRouteNames.fans,
    },
  ];
}
